export default {
  title: 'Ustawienia wyświetlania',
  subtitle: 'Z poniższych list wybierz wykresy, które chcesz wyświetlić na pulpicie.',
  aggregationTitle: 'Zbiór',
  aggregationDescription: 'Te wykresy pokazują wydajność dla całego wybranego przedziału czasu',
};
